/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profilelinknotfounderror4Inputs */

const en_profilelinknotfounderror4 = /** @type {(inputs: Profilelinknotfounderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This profile is no longer connected.`)
};

const de_profilelinknotfounderror4 = /** @type {(inputs: Profilelinknotfounderror4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Profil ist nicht mehr verbunden.`)
};

/**
* | output |
* | --- |
* | "This profile is no longer connected." |
*
* @param {Profilelinknotfounderror4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const profilelinknotfounderror4 = /** @type {((inputs?: Profilelinknotfounderror4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profilelinknotfounderror4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_profilelinknotfounderror4(inputs)
	return de_profilelinknotfounderror4(inputs)
});
export { profilelinknotfounderror4 as "profileLinkNotFoundError" }